// extracted by mini-css-extract-plugin
module.exports = {"hidden":"applyStatus_hidden__cY4wp","textEmphasis":"applyStatus_textEmphasis__bJkUZ","wrap":"applyStatus_wrap__B_TAH"};